import type { CSSProperties } from "react";
import { B, type Tint } from "../tokens";

/** Shared badge look: soft tinted fill, hairline border, small status dot. */
export function badgeStyle(c: Tint): CSSProperties {
  return {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "2px 8px",
    background: c.bg,
    color: c.ink,
    border: `1px solid ${c.stroke}`,
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "18px",
    whiteSpace: "nowrap",
    width: "fit-content",
  };
}

export function BadgeDot({ c }: { c: Tint }) {
  return <span style={{ width: 6, height: 6, borderRadius: 99, background: c.ink, flex: "0 0 auto" }} />;
}

type Status = "active" | "closed" | "draft" | "scheduled" | "archived";

const MAP: Record<Status, { c: Tint; label: string }> = {
  active: { c: B.tints.mint, label: "Active" },
  closed: { c: B.tints.sand, label: "Closed" },
  draft: { c: B.tints.butter, label: "Draft" },
  scheduled: { c: B.tints.sky, label: "Scheduled" },
  archived: { c: B.tints.sand, label: "Archived" },
};

export default function StatusPill({ status }: { status: string }) {
  const key = (status as Status) in MAP ? (status as Status) : "draft";
  const m = MAP[key];
  return (
    <span style={badgeStyle(m.c)}>
      <BadgeDot c={m.c} />
      {m.label}
    </span>
  );
}
